<script setup lang="ts">
defineProps({
  hasLocale: {
    type: Boolean,
    default: false,
  },
});

const { lang, setLang } = await useLocale();
</script>

<template>
  <header
    class="header-v2 w-full bg-white h-[90px] flex flex-col md:flex-row items-center justify-center relative"
  >
    <div
      v-if="hasLocale"
      class="header-v2-langs flex mt-4 md:mt-0 md:absolute md:top-[5%] md:right-[2%]"
    >
      <button
        v-if="lang == 'it'"
        class="no-wrap hover:underline flag-de pl-8 flex items-center"
        @click="setLang('de')"
      >
        <span class="text-xs">Deutsche Sprache</span>
      </button>
      <button
        v-if="lang == 'de'"
        class="no-wrap hover:underline flag-it pl-8 flex items-center"
        @click="setLang('it')"
      >
        <span class="text-xs">Lingua italiana</span>
      </button>
    </div>

    <div class="header-v2-logo flex-grow flex justify-center px-8 py-4 md:p-8">
      <slot></slot>
    </div>
  </header>
</template>

<style scoped></style>
